import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import SalesAMView from './AraiManufacturing/View';
import SalesPIView from './PumpSpareInternational/View';
import SalesPDView from './PumpSpareDomestic/View';
import SalesMDView from './ManufacturingDomestic/View';

function SalesView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [salestype, setsalestype] = useState('');
  const [salescategory, setsalescategory] = useState('');
  const [salesData, setSalesData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}sales/findById/${id}`, {
          headers: authHeader(),
        });
        console.log(response.data);

        setSalesData(response.data);
        setsalestype(response.data.salestype);
        setsalescategory(response.data.salescategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (salestype === 'Pump Spare') {
      if (salescategory === 'Domestic') {
        return <SalesPDView />;
      } else if (salescategory === 'International') {
        return <SalesPIView />;
      }
    } else if (salestype === 'Manufacturing') {
      if (salescategory === 'Domestic') {
        return <SalesMDView />;
      } else if (salescategory === 'International') {
        return <SalesAMView />;
      }
    }
    return null; // Default case
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}sales/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/salesindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  console.log(salesData);

  return (
    <Card className="card">
      <Card.Header className="card-header">
        <h6>VIEW SALES</h6>
        <div>
          <strong>Type:</strong> {salestype} | <strong>Category:</strong> {salescategory}
        </div>

        <div className="view-buttons">
          {(salescategory === "Domestic" || salescategory === "International") && salesData?.status === "Open" && (
            <Link to={`/stosrconvert/${id}`}>
              <button className="button-70">Convert To Sales Rejection</button>
            </Link>
          )}
          {salesData?.status === "Open" && salesData?.status !== "Cancelled" && (
            <Link to={`/salesEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link>
          )}
          <Link to={`/salesindex/${pointindex}`}>
            <button className="button-70">BACK</button>
          </Link>
        </div>
      </Card.Header>
      {renderPageDisplay()}
    </Card>
  );
}

export default SalesView;
